var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('color',{staticClass:"content-padding",class:{
    shadow: !_vm.hasBackgroundColor,
    background: _vm.hasBackgroundColor,
    rounded: _vm.rounded
  },attrs:{"background":_vm.myColor}},[_c('padding',{attrs:{"bottom":_vm.paddingBottom,"left":_vm.paddingLeft,"top":"space-m"}},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }